import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import Banner from '@components/ui-components/banner/component.js';
import Quote from '@components/ui-components/quote/component.js';
import SliderView from '@components/ui-components/slider-view/component.js';
import tags from '@components/ui-components/tags/tags.vue'
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',

        }
    },
    components: {
        'quote-cmp': Quote,
        'banner-cmp': Banner,
        'slider-view-cmp': SliderView,
        'tags-cmp': tags,
    },
    methods: {
        getName(name) {
            let mass = name.split(' ');
            mass = mass.filter((item, index) => index < 2);
            let result = '';
            mass.forEach((item) => {
                result = result + item.split('')[0];
            });
            return result;
        }
    },
    beforeRouteUpdate(to, from, next) {
        const path = to.path.replace(router.history.base, '');
        // this.$root.setDataAnimateFalse();

        Vue.http.get(`templates${path}`, { params: to.query }).then(
            (data) => {
                next();
                // this.$root.setDataAnimateTrue();
                setTimeout(() => {
                    this.template = data.data;
                }, 100);
            },
            () => {
                next('/404');
            }
        );
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/media/view/index.js